import React, { FC } from "react";
import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { Review as ReviewInterface } from "@app/components/base-page/models";

type Props = {
  data: ReviewInterface;
};

export const Review: FC<Props> = ({ data }) => (
  <div className="relative">
    <div
      className={classNames(
        "absolute inset-0 z-10 flex flex-col justify-around",
        "",
        "xl:justify-center",
        "xxl:mx-auto xxl:max-w-container-wide px-5 lg:px-16 xl:px-24",
      )}
    >
      <div className="lg:flex-1"></div>
      <div className={classNames("text-left lg:w-2/3 lg:flex-1", "xxl:w-3/4")}>
        <p
          className={classNames(
            "text-medium text-primary-content mb-3",
            "lg:text-large lg:mb-3",
            "xxl:mb-11 xxl:text-xx-large",
          )}
        >
          {data.review}
        </p>
        <p
          className={classNames(
            "text-regular text-primary-content",
            "xxl:text-medium",
          )}
        >
          {data.author}
        </p>
      </div>
    </div>
    <GatsbyImage
      image={getGatsbyImage(data.image.filename, { layout: "fullWidth" })}
      alt={data.image.alt}
      className={classNames("xxl:h-[945px] h-[576px] w-full")}
    />
  </div>
);
